const library = require('@safe-systems/ss-ui-components');

const { copy } = library;

export default function CAEditCustomerSettingsDirectiveController(
  $q,
  $rootScope,

  alerts,
  orgDataService,
  loaderService
) {
  const vm = this;

  vm.handleSaveCustomerSettingsClick = _handleSaveCustomerSettingsClick;

  function _handleSaveCustomerSettingsClick() {
    loaderService.showViewLoader = true;
    orgDataService.saveCustomer(vm.customer).then(() => {
      alerts.success(copy.admin.customerAdministration.alerts.saveSettingsSuccessful.text);
      $rootScope.canDoSalesforceTicketing = vm.customer.canDoSalesforceTicketing;
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }
}

CAEditCustomerSettingsDirectiveController.$inject = [
  '$q',
  '$rootScope',
  'alerts',
  'orgDataService',
  'loaderService'
];
